import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, User, Bell } from 'lucide-react';
import api from '../../services/api';

export default function TopBar({ title }) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [overdueCount, setOverdueCount] = useState(0);
  const [bellOpen, setBellOpen] = useState(false);
  const [overdueTasks, setOverdueTasks] = useState([]);

  useEffect(() => {
    api.get('/api/tasks/due-today')
      .then(r => {
        const tasks = r.data || [];
        const today = new Date().toISOString().split('T')[0];
        const overdue = tasks.filter(t => t.due_date < today);
        setOverdueCount(overdue.length);
        setOverdueTasks(overdue.slice(0, 5));
      })
      .catch(() => {});
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <header className="h-12 flex items-center justify-between px-4 border-b border-zinc-200 bg-white relative">
      <h1 className="text-sm font-semibold text-zinc-700">{title}</h1>
      <div className="flex items-center gap-3">
        {/* Notification bell */}
        <div className="relative">
          <button
            onClick={() => setBellOpen(o => !o)}
            className="relative text-zinc-400 hover:text-zinc-700 transition-colors">
            <Bell size={16} />
            {overdueCount > 0 && (
              <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[9px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                {overdueCount > 9 ? '9+' : overdueCount}
              </span>
            )}
          </button>
          {bellOpen && (
            <>
              <div className="fixed inset-0 z-10" onClick={() => setBellOpen(false)} />
              <div className="absolute right-0 top-7 z-20 w-72 bg-white border border-zinc-200 rounded-lg shadow-lg">
                <div className="px-3 py-2 border-b border-zinc-100">
                  <p className="text-xs font-semibold text-zinc-700">
                    {overdueCount > 0 ? `${overdueCount} overdue task${overdueCount > 1 ? 's' : ''}` : 'No overdue tasks'}
                  </p>
                </div>
                {overdueTasks.length === 0 ? (
                  <p className="text-xs text-zinc-400 px-3 py-4">All caught up.</p>
                ) : (
                  <div className="divide-y divide-zinc-50">
                    {overdueTasks.map(t => (
                      <button key={t.id} onClick={() => { navigate(`/leads/${t.lead_id}`); setBellOpen(false); }}
                        className="w-full text-left px-3 py-2.5 hover:bg-zinc-50 transition-colors">
                        <p className="text-xs font-medium text-zinc-800 truncate">{t.title}</p>
                        <p className="text-xs text-red-500 mt-0.5">Due {t.due_date}</p>
                      </button>
                    ))}
                  </div>
                )}
                {overdueCount > 5 && (
                  <div className="px-3 py-2 border-t border-zinc-100">
                    <p className="text-xs text-zinc-400">+{overdueCount - 5} more overdue tasks</p>
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        <span className="text-xs text-zinc-500 flex items-center gap-1">
          <User size={13} /> {user.name || user.email}
        </span>
        <button onClick={logout} className="text-zinc-400 hover:text-red-500 transition-colors">
          <LogOut size={15} />
        </button>
      </div>
    </header>
  );
}
